import { MutationTree } from 'vuex'
import { ContentState } from './state'
import { Content } from '../../types'

const mutations: MutationTree<ContentState> = {
  JW_VIDEO_UPDATED: (state, jwVideo: object) => {
    state.jwVideo = jwVideo
  },

  CURRENT_VIDEOS_UPDATED: (state, videos: Array<Content>) => {
    state.currentVideos = videos
  },

  VIDEO_STATUS_UPDATED: (state, video: Content) => {
    const videoForUpdate: Content | undefined = state.currentVideos.find(
      vid => vid.id === video.id
    )
    if (videoForUpdate) {
      videoForUpdate.user_status = video.user_status
    }
  },

  CURRENT_QUIZZES_UPDATED: (state, quizzes: Array<Content>) => {
    state.currentQuizzes = quizzes
  },

  QUIZ_STATUS_UPDATED: (state, quiz: Content) => {
    const quizForUpdate: Content | undefined = state.currentQuizzes.find(
      q => q.id === quiz.id
    )
    if (quizForUpdate) {
      quizForUpdate.user_status = quiz.user_status
    }
  },

  CURRENT_EXERCISES_UPDATED: (state, exercises: Array<Content>) => {
    state.currentExercises = exercises
  },

  EXERCISE_STATUS_UPDATED: (state, exercise) => {
    const exerciseForUpdate: Content | undefined = state.currentExercises.find(
      q => q.id === exercise.id
    )
    if (exerciseForUpdate) {
      exerciseForUpdate.user_status = exercise.user_status
    }
  },

  CURRENT_LABS_UPDATED: (state, labs: Array<Content>) => {
    state.currentLabs = labs
  },

  LAB_STATUS_UPDATED: (
    state,
    userLabStatus: { lab: string; status: string; modified: string }
  ) => {
    const { lab: id, status, modified } = userLabStatus
    const labForUpdate: Content | undefined = state.currentLabs.find(
      l => l.id === id
    )
    if (labForUpdate) {
      labForUpdate.user_status = status
      labForUpdate.user_status_modified = modified
    }
  },

  CURRENT_IFRAMES_UPDATED: (state, iframes: Array<Content>) => {
    state.currentIFrames = iframes
  },

  IFRAME_STATUS_UPDATED: (
    state,
    iframeIdAndStatus: { iframeId: string; status: string }
  ) => {
    const { iframeId: id, status } = iframeIdAndStatus
    const iframeForUpdate: Content | undefined = state.currentIFrames.find(
      q => q.id === id
    )
    if (iframeForUpdate) {
      iframeForUpdate.user_status = status
    }
  },

  CURRENT_BOOKMARKS_UPDATED: (state, bookmarks) => {
    state.currentBookmarks = bookmarks
  },

  PLAYING_VIDEO_ID_UPDATED: (state, videoId: string) => {
    state.playingVideoId = videoId
  },

  PLAYING_VIDEO_TIME_UPDATED: (state, time: number) => {
    state.playingVideoTime = time
  },

  IS_WATCHING_FULLSCREEN_UPDATED: (state, isWatchingFullscreen: boolean) => {
    state.isWatchingFullscreen = isWatchingFullscreen
  },

  CURRENT_QUIZ_ID_UPDATED: (state, quizId: string) => {
    state.currentQuizId = quizId
  },

  IS_CONTENT_LOADING_UPDATED: (state, isLoading: boolean) => {
    state.isContentLoading = isLoading
  },

  CURRENT_HOVERED_NOTE_UPDATED: (state, id: string) => {
    state.currentHoveredNote = id
  },

  COURSES_FOR_BOOKMARKS_UPDATED: (state, courses: Array<object>) => {
    state.coursesForBookmarks = courses
  },

  VIDEOS_FOR_BOOKMARKS_UPDATED: (state, videos: Array<Content>) => {
    state.videosForBookmarks = videos
  },
}

export default mutations
